<template>
  <div
    v-click-outside="$_onClosePick"
    class="lv-state-date"
  >
    <div
      class="lv-state-date__date d-flex justify-space-between align-center"
      @click="$_onOpenPick"
    >
      <p v-if="_hasValue">{{$_setDateDisplay(value)}}</p>
      <p v-else class="lv-state-date__placeholder">{{_placeholder}}</p>
      <v-icon
        size="20"
        class="icon"
      >mdi-calendar</v-icon>
    </div>
    <transition mode="out-in">
      <div
        class="lv-state-date__picker"
        :class="{active: isActive.picker}"
      >
        <v-date-picker
          v-model="value"
          noTitle
          :range="isDuration"
        ></v-date-picker>
      </div>
    </transition>
  </div>
</template>

<script>
import H_time from "@/helpers/time";

export default {
  props: {
    isDuration: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    }
  },
  data () {
    return {
      isActive: {
        picker: false,
      },
      value: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).to,
    }
  },
  computed: {
    _placeholder() {
      return this.placeholder
        ? this.placeholder
        : this.isDuration
        ? "選擇日期區間"
        : "選擇日期";
    },
    _hasValue() {
      if (!this.value) return false;
      return typeof this.value === "string"
        ? this.value !== null
        : this.value.length === 2;
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.isDuration) {
          if (newVal.length === 2) {
            const isDate1GreaterThenDate2 = H_time.isAfter(this.$moment(this.value[0]), this.$moment(this.value[1]));
            const start = isDate1GreaterThenDate2 ? this.value[1] : this.value[0];
            const end = isDate1GreaterThenDate2 ? this.value[0] : this.value[1];
            this.$emit("input", {start, end});
          }
        } else this.$emit("input", this.value);
      }
    }
  },
  methods: {
    $_setDateDisplay(value) {
      if (!value) return this._placeholder;
      if (typeof value === "string") return value;
      else if (value.length === 2){
        const isDate1GreaterThenDate2 = H_time.isAfter(this.$moment(value[0]), this.$moment(value[1]));
        const start = isDate1GreaterThenDate2 ? value[1] : value[0];
        const end = isDate1GreaterThenDate2 ? value[0] : value[1];
        return `${start} ~ ${end}`;
      } else return "";
    },
    $_onOpenPick() {
      this.isActive.picker = true;
    },
    $_onClosePick() {
      this.isActive.picker = false;
    }
  }
}
</script>
<style lang="scss">
  @import "../assets/scss/lv-state-date.scss";
</style>